//处理派发的事件并更新数据

import {
    ACTION_SET_EDITOR_WORDS,
    ACTION_SET_DELETE_EDITOR_WORD

} from './action'


export default {
    //拆解的单词信息
    editor_words(words = [], action) {
        const { type, payload } = action;
        switch (type) {
            case ACTION_SET_EDITOR_WORDS:
                return payload;
            case ACTION_SET_DELETE_EDITOR_WORD:
                let new_words = words.slice();
                new_words.splice(payload, 1);
                return new_words;
        }
        return words;
    }

}